import { Button, ButtonProps, withStyles } from '@material-ui/core';

const StyledButton = withStyles(() => ({
  root: {
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: 'white',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(Button);

const OutlinedButton: React.FC<ButtonProps> = (props) => {
  const { style, ...restProps } = props;
  return (
    <StyledButton
      style={{
        height: '30px',
        ...(style ? style : {}),
      }}
      variant="contained"
      {...restProps}
    >
      {props.children}
    </StyledButton>
  );
};

export default OutlinedButton;
